module.exports = __webpack_public_path__ + "static/img/5.0a7ea91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/5.png
// module id = lJEA
// module chunks = 19